<div class="assigned-reading-status">
  <div
    id="unassigned"
    class="text-ellipsis"
    *ngIf="
      (state && !state.isAssigned && !state.isActivated) ||
      (state && state.ownership && state.ownership.assignedToUser[0] &&
        state.ownership.assignedToUser[0].externalUser === true &&
        state.extAppWorkItemState === 'External_Read_Lock_Added')
    "
    [tooltip]="'workloadManager.listContainer.workItem.unassignedLabel' | translate"
    [overflowOnly]="true"
  >
    {{ 'workloadManager.listContainer.workItem.unassignedLabel' | translate }}
  </div>

  <div
    id="assigned"
    class="text-ellipsis"
    *ngIf="
      state &&
      !state.isActivated &&
      state.isAssigned &&
      ((state.ownership && state.ownership.assignedToUser[0] &&
        state.ownership.assignedToUser[0].externalUser === false) ||
        state.extAppWorkItemState === 'RA1000_Approver_Added')
    "
    [tooltip]="assigned"
    [overflowOnly]="true"
  >
    <ng-container [ngTemplateOutlet]="assigned"></ng-container>
  </div>

  <div id="locked-exam" class="text-ellipsis" *ngIf="state && state.isActivated" [tooltip]="lockedExam" [overflowOnly]="true">
    <ng-container [ngTemplateOutlet]="lockedExam"></ng-container>
  </div>
</div>

<ng-template #assigned>
  <span id="assignee-name" [ngStyle]="colorAssigntoColumn && {'color': userId === state.ownership.assignedToUser[0].userName ? '#8FBF9D' : '#F5A147'}">
    {{ state && state.ownership.assignedToUser[0] | doctorName: userId }}</span
  >
</ng-template>

<ng-template #lockedExam>
  <span id="reader-name-span" [ngStyle]="colorAssigntoColumn && {'color': userId === state.ownership.assignedToUser[0].userName ? '#8FBF9D' : '#F5A147'}">
    {{ state && state.activity.readingDto | doctorName: userId }}&nbsp;</span
  >
</ng-template>
